import dayjs from 'dayjs'

export const calculateAge = (dateOfBirth: string) => {
    const today = dayjs()
    const birthDate = dayjs(dateOfBirth)
    return today.diff(birthDate, 'year')
}
